import { setupSpanishZodErrors } from '@app/shared';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from './components/theme/ThemeProvider';
import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './i18n/I18nProvider';
import { queryClient } from './lib/queryClient';
import { AppRouter } from './router';
// Tipografía base: Archivo (Google Font libre), self-hosted vía Fontsource
// (se bundlea con Vite → servido desde el propio origen, sin CDN, offline-friendly).
import '@fontsource-variable/archivo';
import './styles/index.css';

// Sprint 7 #3: mensajes de validación de Zod en español en toda la app.
setupSpanishZodErrors();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró el elemento #root en index.html');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
          <Toaster />
        </QueryClientProvider>
      </I18nProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
